export const ApiUrls = {
    login: 'admin/login',
    forgotPassword: 'admin/forgotPassword',
    resetPassword: 'admin/resetPassword/',
    // profile
    profile: 'admin/profile',
    editProfile: 'admin/editProfile',
    // dashboard
    dashboard: 'admin/dashboard',
    // user
    userList: 'admin/listOfUsers',
    viewUser: 'admin/user/',
    editUser: 'admin/user',
    deleteUser: 'admin/user',
    deleteMultiUser: 'admin/multiUser',
    // hospital
    hospitalList: 'admin/hospitalList',
    addHospital: 'admin/hospital',
    editHospital: 'admin/hospital',
    deleteHospital: 'admin/hospital',
    deleteMultiHospital: 'admin/multiHospital',
    viewHospital: 'admin/hospital/',
    viewPatientListHospital: 'admin/viewPatients',
    viewPatientHospital: 'admin/viewPatients',
    viewPlasmaDonatedPatientListHospital: 'admin/viewPlasmaDonatedPatients',
    viewPlasmaDonatedPatientHospital: 'admin/viewPlasmaDonatedPatients',
    // notification
    notification: 'admin/broadcastNotifications',
    // testc center
    testCenterList: 'admin/testCenterList',
    addTestCenter: 'admin/testCenter',
    editTestCenter: 'admin/testCenter',
    deleteTestCenter: 'admin/testCenter',
    deleteMultiTestCenter: 'admin/multiTestCenter',
    viewTestCenter: 'admin/testCenter/',
    viewPatientListTestCenter: 'admin/viewPatients',
    viewPatientTestCenter: 'admin/viewPatients',
    ViewPlasmaDonatedPatientTestCenterList: 'admin/viewPlasmaDonatedPatients',
    ViewPlasmaDonatedPatientTestCenter: 'admin/viewPlasmaDonatedPatients',
    // helpline
    helplineList: 'admin/helplineList',
    addHelpline: 'admin/helpline',
    editHelpline: 'admin/helpline',
    viewHelpline: 'admin/helplineList',
    deleteHelpline: 'admin/helpline',
    deleteMultiHelpline: 'admin/multiHelpline',
    // change password
    changePassword: 'admin/changePassword',
    // faq
    faqList:'admin/faqList',
    addFaq:'admin/faq',
    editFaq:'admin/faq',
    deleteFaq:'admin/faq',
    viewFaq:'admin/faq/',
    // static content
    staticContentList:'static/staticPageList',
    editStaticContent:'static/staticPage',
    viewStaticContent:'static/staticPage/'
}
